import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { IWebhookIntegration } from '@services/integrations.service';
import { generateGUID } from 'src/app/functions/functions'
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
	selector: 'app-edit-webhook-integration',
	templateUrl: './edit-webhook-integration.component.html',
	styleUrls: ['./edit-webhook-integration.component.scss']
})
export class EditWebhookIntegrationComponent {

	/** Update the Image */
	@Output() imageUpdated = new EventEmitter<any>();

	/** Form Group */
	dialogForm: FormGroup;

	/**
	 * Default Constructor
	 * @param globalFunctions globalFunctions
	 * @param fb Form Builder
	 * @param dialogRef Referense to the Dialog box
	 * @param globalFunctions globalFunctions
	 * @param dialogData  object interface
	 * @param clipboard clipboard
	 */
	constructor(
		private globalFunctions: GlobalFunctions,
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<EditWebhookIntegrationComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: IWebhookIntegration,
		private clipboard: Clipboard
	) {

		this.dialogForm = this.fb.group({
			AccountUID:[this.dialogData.AccountUID || ""],
			/** Organisation Webhook ID */
			OrganisationWebhookID: [this.dialogData.OrganisationWebhookID || 0],
			/** Organisation ID */
			OrganisationID: [this.dialogData.OrganisationID || 0],
			/** Organisation UID */
			OrganisationUID: [this.dialogData.OrganisationUID || ""],
			/** Webhook ID */
			WebhookID: [this.dialogData.WebhookID || 0],
			/** Webhook UID */
			WebhookUID: [this.dialogData.WebhookUID || generateGUID()],
			/** Client WWebhook ID */
			ClientWebhookID: [this.dialogData.ClientWebhookID || '', Validators.required],
			/** HTTP Host Name */
			Host: [this.dialogData.Host.toLowerCase() || ''],
			/** Path on Host */
			Path: [this.dialogData.Path.toLowerCase() || ''],
			/** fully Qualified Path Name*/
			FQN: [this.dialogData.FQN.toLowerCase() || ''],
			/** Webhook Description */
			Description: [this.dialogData.Description || ''],
			/** Auto Build Sensors */
			AutoBuild: [this.dialogData.AutoBuild],
			/** Webhook Enabled */
			Enabled: [this.dialogData.Enabled],
			/** Webhook Type ID*/
			WebhookTypeID: [this.dialogData.WebhookTypeID || 0],
			/** Webhook Type*/
			Type: [this.dialogData.Type || 0, Validators.required],
			/** Webhook Type Path*/
			TypePath: [this.dialogData.TypePath || ""],
			/** Webhook Type Description*/
			TypeDescription: [this.dialogData.TypeDescription || ''],
			/** Webhook Type Security Code */
			TypeAzureCode: [this.dialogData.TypeAzureCode || ""],
			/** Webhook Deleted */
			Deleted: [this.dialogData.Deleted],

			/** Not a neuron sensor API configuration */
			/** Neuron Sensor API Code*/
			NeuronSensorAPI: [""],
			/** Neuron Sensor System Code*/
			NeuronSensorSystem: [""],
			/** Is a neuron Sensors Webhook */
			NeuronSensors: [false]
		});
	}

	/**
	 * Cancel button for dialog
	 */
	onCancelClick(): void {
		if (this.dialogForm.dirty) {
			this.globalFunctions.UserConfirm$('Lose any unsaved changes?').subscribe(OKResult => {
				if (OKResult) { this.dialogRef.close(); }
				// do nothing if result is false
			});
		} else { this.dialogRef.close(); }
	}

	/**
	 * copy To Clipboard
	 * @param value
	 */
	copyToClipboard(value: string) {
		try {
			if (this.clipboard.copy(value)) {
				this.globalFunctions.DisplaySnackBar({
					message: "Copied to clipboard",
					action: "",
					duration: 2000
				});
			};
		} catch (error) { console.error(error); }
	}


	copyFQNToClipboard() {
		try {
			const value = `${this.dialogData.Host}${this.dialogData.Path}?code=${this.dialogData.TypeAzureCode}`;
			if (this.clipboard.copy(value)) {
				this.globalFunctions.DisplaySnackBar({
					message: "Copied to clipboard",
					action: "",
					duration: 2000
				});
			};
		} catch (error) { console.error(error); }
	}
}
